exports = module.exports = require("../../../node_modules/_css-loader@2.1.1@css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popupContainer[data-v-22f7b652]{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);width:420px;height:500px;border-radius:20px}.main-container[data-v-22f7b652]{height:300px}.img[data-v-22f7b652]{width:120px;margin-bottom:20px}\n", ""]);

